import { Component, inject, OnInit, signal } from '@angular/core';
import { VersionService } from './services/proxy';
import { ZendraLocalizationPipe } from '../pipes/zendra-localization.pipe';

@Component({
  selector: 'zn-version',
  imports: [ZendraLocalizationPipe],
  templateUrl: './zn-version.html',
  styleUrl: './zn-version.scss',
})
export class ZnVersion implements OnInit {
  private readonly service = inject(VersionService);
  
  version = signal('');

  constructor() {}

  ngOnInit(): void {
    this.service.getVersion().subscribe({
      next: response => {
        this.version.set(response.version);
      },
      error: error => console.log(error),
    });
  }
}
